angular
    .module("skillBuilderSaaS")
    .directive("groupFullPathName", (["$http", function ($http) {
        return {
            restrict: "C",
            link: function (_scope, element, attr) {
                var id = attr.groupId;
                element.tooltip();
                $(element).bind("click", function () {
                    $http.get("api/groups/" + id + "/fullPathName").then(function (result) {
                        element[0].outerText = result.data;
                    })
                        .catch(angular.noop);
                });
            }
        };
    }]));
